import React from 'react';
import Button from 'components/Buttons';

export const ActionButtons = ({ isLoading, isDirty, hasAddress, onCancel }) => {
  return (
    <div className="flex flex-wrap lg:flex-row flex-col mt-[40px] justify-end gap-[20px] lg:gap-[44px]">
      <Button
        loading={isLoading}
        whiteOutline
        primary
        className={`!h-[56px] save_changes !py-[16px] !text-[20px] font-[700] !px-[56px] !font-[montserrat] !rounded-[56px] !bg-[#2B364B] !text-white ${
          isDirty ? "!bg-[#2B364B] !text-[#fff]" : ""
        }`}
        disabled={!hasAddress}
        type="submit"
      >
        Save Changes
      </Button>

      <Button
        transparent
        className={`!h-[56px] !py-[16px] !text-[20px] font-[700] !px-[56px] !font-[montserrat] !rounded-[56px] !border-2 !border-[#2B364B] !text-[#2B364B] ${
          isDirty ? "!border-2 !border-[#2B364B] !text-[#2B364B]" : ""
        }`}
        type="button"
        disabled={!hasAddress}
        onClick={onCancel}
      >
        Cancel
      </Button>
    </div>
  );
};
